import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import NavRoleOrg from '../../components/nav-role-org'
import NavTitle from '../../components/nav-title'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import CardCustom from '../../components/custom/card-custom'
import TextNavTitle from '../../components/TextNavTitle'
import { useSelector } from 'react-redux'

dayjs.extend(customParseFormat)

function PimNewResignsPage() {
  const navigate = useNavigate()
  const locaiton = useLocation()
  const menuSubList = useSelector((state) => state.allMenuReducer.allMenu)
  const [newMenu, setNewMenu] = useState([])
  useEffect(() => {
    if (menuSubList && menuSubList.allMenu) {
      const menuMain = menuSubList.allMenu.find((item) => item.id === 11) //id emp

      if (menuMain) {
        const subMenu = menuMain.submenu.find((item) => item.menuId === 4) //id "Monthly"

        if (subMenu?.menuSubList.length > 0) {
          setNewMenu(subMenu?.menuSubList)
        }
      }
    }
  }, [menuSubList])

  const pathname = locaiton.pathname

  const chkIsSubMenu = (d) => {
    return pathname === d.link
  }

  return (
    <>
      <Row>
        <NavTitle>
          <TextNavTitle>Monthly Report</TextNavTitle>
        </NavTitle>
        <NavRoleOrg />
        <Col xl={12}>
          <CardCustom style={{ minHeight: '83vh' }}>
            <div className="p-3">
              <Row>
                <Col
                  xl={12}
                  className=" "
                  style={{
                    gap: '1.5rem',
                    flexWrap: 'wrap'
                  }}
                >
                  <div className="d-flex justify-content-between pt-2 pb-2">
                    <div className="my-auto d-flex">
                      {newMenu.map((radio, idx) => (
                        <h5
                          key={idx}
                          id={`title-${idx}`}
                          type="radio"
                          variant=""
                          name="title"
                          className={`border-0 my-auto mb-0 pointer-event fw-bold me-3  ${
                            chkIsSubMenu(radio) ? '' : 'opacity-25'
                          }`}
                          onClick={(e) => {
                            navigate(radio.link)
                          }}
                          style={{
                            fontSize: '14px'
                          }}
                        >
                          {radio.label}
                        </h5>
                      ))}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <Outlet />
          </CardCustom>
        </Col>
      </Row>
    </>
  )
}

export default PimNewResignsPage
